import { render, staticRenderFns } from "./CardAttachment.vue?vue&type=template&id=1441756e&scoped=true&"
import script from "./CardAttachment.vue?vue&type=script&lang=js&"
export * from "./CardAttachment.vue?vue&type=script&lang=js&"
import style0 from "./CardAttachment.vue?vue&type=style&index=0&id=1441756e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1441756e",
  null
  
)

export default component.exports